import React from 'react';
import { Wrapper } from './styled';
import { connect } from 'react-redux';

import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import Main from './Main';
import Cases from './Cases';
import Advantages from './Advantages';
import Cameras from './Cameras';
import TariffList from './tariffs';
import RequestSection from './request';
import AppLinks from './AppLinks';
import SeoBlock from './SeoBlock';
import Questions from './questions';

const Videocontrol = (props) => {
    const { type, features, currentCity } = props;

    return (
        <Wrapper>
            <Main type={type} city={currentCity} />
            <Cases features={features} activeTab={type} />
            <Advantages />
            <Cameras />
            <TariffList bgColor={COLORS.lightGrey} />
            <RequestSection bgColor={COLORS.white} nonTopPadding={true} textColor={COLORS.black}/>
            <AppLinks bgColor={COLORS.black} nonTopPadding />
            <SeoBlock bgColor={COLORS.white}
                      currentCity={currentCity}
                      textColor={COLORS.black} />
            <Questions />
        </Wrapper>
    );
};

const mapStateToProps = state => ({
    isAuth: state.auth.isAuth,
    currentCity: state.city.currentCity
});
export default connect(mapStateToProps)(Videocontrol);
